import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

const MemberChildDataSchema = z.object({});

export type IMemberChildData = z.infer<typeof MemberChildDataSchema>;

export const ChildMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Child),
    MemberChildDataSchema
  );

export type IMemberChild = z.infer<typeof ChildMemberSchema>;

export const getEmptyChildMemberData = (): IMemberChildData => ({});

export function getEmptyChildMember(
  legalClient: ILegalClient,
  idRelationship: number,
  data?: IMemberChildData
): IMemberChild {
  const member: IMemberChild = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
    data: data || getEmptyChildMemberData(),
  };

  return member;
}
